<template>
  <div @click="getViewProduct(product._id, product.providerId)" class="curp">
    <div
      class="card-products card-h curp"
      :class="{ 'card-sm-h': size == 'sm', 'bg-white': background == 'white' }"
    >
      <div class="row d-w-100">
        <div
          class="col-xl-4 col-lg-4 col-md-5 col-sm-5 col-12 align-self-center content-img-h"
        >
          <div class="header-product">
            <LazyImage
              :src="product.images[0] || noImage"
              :alt="`${product.name}`"
              imgClasses="responsive-image"
            />
          </div>
        </div>
        <div
          class="col-xl-8 col-lg-8 col-md-7 col-sm-7 col-12 align-self-center "
          :class="{
            'pt-1': size == 'sm',
            'pt-4 pb-2': size != 'sm'
          }"
        >
          <div class="content-card">
            <!-- aqui la etiqueta de promocion. -->
            <span
              class="product-badge mb-2 w-30"
              v-if="promo"
              :class="{
                offert: typeBadge === 'offert',
                hight: typeBadge === 'hight',
                info: typeBadge === 'info',
                important: typeBadge === 'important'
              }"
            >
              Special Combo!
            </span>

            <h4 class="card-title">
              {{ product.name }}
            </h4>

            <div class="excerpt short-description" v-if="excerpt">
              <p v-if="product.short_description">
                {{ product.short_description }}
              </p>

              <p v-else-if="product.description">
                {{ product.description }}
              </p>

              <p v-else>
                An experience that will make you enjoy incredible moments and
                create unforgettable memories, transforming the way you see the
                world. Live something unique!
              </p>
            </div>

            <div
              v-if="size != 'sm'"
              :class="{
                'col-12 align-self-center p-0': size == 'sm',
                'col-xl-6 col-lg-6 col-md-9 col-sm-12 col-12 p-0': size != 'sm'
              }"
            >
              <div class="experience-info-li p-0">
                <div class="content-info-li" v-if="source === 'RHOMTRIP'">
                  <div>
                    <i class="flaticon-employees "></i>
                    <span>{{ product.passengers.maximum }} PAX</span>
                  </div>
                </div>

                <div class="content-info-li" v-if="source === 'RHOMTRIP'">
                  <div>
                    <i class="flaticon-briefcase"></i>
                    <span> {{ product.bags.maximum }} Bags</span>
                  </div>
                </div>

                <div
                  class="content-info-li"
                  v-if="source === 'VENTRATA' && product.duration"
                >
                  <div>
                    <i class="flaticon-wall-clock"></i>

                    <span>
                      {{ product.duration }}
                    </span>
                  </div>
                </div>

                <div
                  class="content-info-li"
                  v-if="source === 'RHOMTRIP' && product.type === 'TOUR'"
                >
                  <div>
                    <i class="flaticon-wall-clock"></i>
                    <span>
                      {{ product.duration.value }}
                      {{
                        getUnitTime(
                          product.duration.unit,
                          product.duration.value
                        )
                      }}</span
                    >
                  </div>
                </div>

                <!-- <div class="content-info-li" v-if="commission">
                  <el-tooltip content="Commission" placement="bottom">
                    <div>
                      <i class="flaticon-tools-money-bag"></i>
                      <span>10%</span>
                    </div>
                  </el-tooltip>
                </div> -->
              </div>
            </div>

            <div class="experience-info" v-if="size == 'sm'">
              <div class="content" v-if="source === 'RHOMTRIP'">
                <i class="flaticon-employees "></i>
                <span>{{ product.passengers.maximum }}</span>
              </div>

              <div class="content" v-if="source === 'RHOMTRIP'">
                <i class="flaticon-briefcase"></i>
                <span> {{ product.bags.maximum }}</span>
              </div>

              <div
                class="content"
                v-if="source === 'RHOMTRIP' && product.type === 'TOUR'"
              >
                <i class="flaticon-wall-clock"></i>
                <span>
                  {{ product.duration.value }}
                  {{
                    getUnitTime(product.duration.unit, product.duration.value)
                  }}</span
                >
              </div>

              <div
                class="content"
                v-if="source === 'VENTRATA' && product.duration"
              >
                <i class="flaticon-wall-clock"></i>

                <span>
                  {{ product.duration }}
                </span>
              </div>

              <!-- <div class="content" v-if="commission">
              <el-tooltip content="Commission" placement="bottom">
                <div>
                  <i class="flaticon-tools-money-bag"></i>
                  <span>10%</span>
                </div>
              </el-tooltip>
            </div> -->
            </div>

            <div class="footer-product" v-if="price && product.pricing">
              <div class="price-card-product w-100">
                From<span>
                  {{ product.currency.symbol }}
                  {{ product.pricing.amount }}
                  {{ product.currency.code }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BCarousel } from "bootstrap-vue";
export default {
  name: "cardVertical",
  components: { "b-carousel": BCarousel },

  props: {
    product: {
      type: Object,
      required: false,
      default: null,
      description: ""
    },

    index: {
      type: Number,
      required: false,
      default: 0,
      description: "index"
    },
    excerpt: {
      type: Boolean,
      required: false,
      default: false,
      description: "Show excerpt"
    },
    size: {
      type: String,
      required: false,
      default: "",
      description: "lg-md-sm"
    },
    category: {
      type: Boolean,
      required: false,
      default: true,
      description: "show type product"
    },
    price: {
      type: Boolean,
      required: false,
      default: true,
      description: "Show price in card"
    },
    background: {
      type: String,
      required: false,
      default: "transparent",
      description: "back color card"
    },
    promo: {
      type: Boolean,
      required: false,
      default: false,
      description: "Show promotion in card"
    },
    typeBadge: {
      type: String,
      required: false,
      default: "offert",
      description: "badge of the promotions"
    },
    source: {
      type: String,
      required: false,
      default: "RHOMTRIP",
      description: "Source of the product"
    }
  },
  data() {
    return {
      noImage: require("rhomtrip_assets/src/img/no-image-available.png")
    };
  },
  methods: {
    async getViewProduct(productId, providerId = null) {
      if (this.source === "RHOMTRIP") {
        this.$router.push(`/experiences/rhomtrip/${productId}`);
      } else {
        this.$router.push(
          `/experiences/ventrata/${productId}?providerId=${providerId}`
        );
      }
    },
    getUnitTime(unit, value) {
      if ("HOURS" === unit) {
        return value > 1 ? "hours" : "hour";
      } else if ("MINUTES" === unit) {
        return value > 1 ? "Minutes" : "Minute";
      } else if ("DAYS" === unit) {
        return value > 1 ? "days" : "day";
      } else {
        return "";
      }
    }
  }
};
</script>
